<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HgEKN7/cover.jpeg?1684229399446" alt="This image is the cover for the book Mr. President Pampers His Little Wife, Volume 4"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mr. President Pampers His Little Wife, Volume 4
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>In order to repay the debt her mother owed her, she had come to pay them, and had suffered all the humiliation and torment, from being a daughter to being a lowly maid.</strong></p><p>He loved and hated her, and the pleasure of revenge clouded his eyes and blinded his heart.</p><p>"Big Bro, can you not be so hypocritical?"</p><p>"No matter, taking care of me is your responsibility!"</p><p>The president of the black department is ruthless and ruthless, but he is also a villain...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Guo ZiYuan, Lemon Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?af0c9bde